// 购买须知
export const buyNote = `1.依据法律要求，我们坚决反对作品版权的炒作、违规交易、侵权方式使用等行为。
2.版权作品为虚拟商品，仅限实名认证的中国大陆用户且满18岁人群购买。
3.版权商品一经出售不支持退换。
4.为更好服务无界版图平台的各位用户，请各位用户务必审慎阅读并同意相关协议规则后进行相应操作，以免造成不必要损失。
`

// 所有权须知
export const ownerNote = `1.您在购买版权所有权后，版权方将同时向您转让作品的具体信息，包括但不限于作品名称、尺寸、创作年代、作品介绍等，如作品涉及肖像权或物权的，相应权利将同时转授权至版权受让方。
2.版权方向您转让的原创作品版权的著作财产权包括但不限于复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权，以及著作权人享有的其他著作财产相关权利（人身权除外）。
3.转让时限为永久。
4.版权转让后，版权方无权限制您就作品版权使用权的授权活动，亦不能再就版权收益向您提供进一步要求。
5.版权方同意，您有权为指定作品及其作者进行线上线下媒体宣传推广；作品版权在宣传、推广活动时涉及的作者信息（含作者姓名、肖像、个人简介）和作品信息的，您有权无限制免费使用。
6.以上权利转让是排他的、独占的。版权方不得将指定作品的版权再次转让、授权给任何第三方，也不得自行开发。版权方违反上述约定的，应向您承担赔偿责任。
7.您需注意，您购买版权所有权后，仅可自身持有或使用或出售作品使用权、改编权，不得再次对作品版权所有权进行交易。未经无界版图平台书面同意，您不得自行通过除无界版图平台外的其他渠道或方式，就作品版权进行任何形式的处分或授权。`

export const ownerNotAdaptNote = `
1.特别提醒您注意：本作品的受让权利仅限于<span class="error-color font-semibold">除改编权之外</span>的著作财产权；作品的署名权、修改权等人身权权利以及改编权仍由原创作者享有。
2.针对于本作品，版权方向您转让的原创作品版权的著作财产权为除改编权之外的其他财产性权利，包括复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、翻译权、汇编权。
3.您理解并同意，本作品版权所有权不含改编权（即改变作品形式或类型，创作出具有独创性的新作品的权利），您不取得改编权，您只能对除改编权之外的其他财产权利进行处置，无法对作品进行任何形式的改编，也无权将作品的改编权授予第三方或进行任何方式的处分。
4.您在购买版权所有权后，版权方将同时向您转让作品的具体信息，包括但不限于作品名称、尺寸、创作年代、作品介绍等，如作品涉及肖像权或物权的，相应权利将同时转授权至版权受让方。
5.转让时限自您受让成功之时起，直至您将该作品版权所有权再次售出。
6.版权转让后，版权方无权限制您就作品版权使用权的授权活动，亦不能再就版权收益向您提供进一步要求。
7.版权方同意，您有权为指定作品及其作者进行线上线下媒体宣传推广；作品版权在宣传、推广活动时涉及的作者信息（含作者姓名、肖像、个人简介）和作品信息的，您有权无限制免费使用。
8.以上权利转让是排他的、独占的。版权方不得将指定作品的版权再次转让、授权给任何第三方，也不得自行开发。版权方违反上述约定的，应向您承担赔偿责任。
9.未经无界版图平台书面同意，您不得自行通过除无界版图平台外的其他渠道或方式，就作品版权进行任何形式的处置或授权。
`

// 使用权须知
export const useNote = `1.标准授权：无界版图授权您在有限的商业用途中使用作品，具体授权范围以授权许可协议为准。
2.扩展授权：无界版图授权您在较为广泛的商业用途中使用作品，具体授权范围以授权许可协议为准。
3.商品类授权：无界版图授权您在较为广泛的商业用途中使用作品，具体授权范围以授权许可协议为准。
4.购买许可使用权后，不视为所有权或版权已转让给被授权人，除协议中明确陈述的授权之外，无界版图未授予被授权人对作品的其他任何权利。
5.您不得超出授权协议条款所约定和允许的使用范围。`

// 改编权须知
export const adaptNote = `1.您按页面提示购买作品改编权后，可将作品改编为具有独创性的新作品，但仅限改编为美术作品，未经允许您不得将原作品改编成除美术作品之外的其他类型。
2.您在获得作品改编权后，不得侵犯原作者的署名权、修改权、保护作品完整权等作品著作人身权利，亦不得侵犯未经授权的作品其他财产权利。
3.改编作品创作完成后，您依法享有改编作品的完整著作权，并享有包括但不限于许可他人复制、发行、出租、通过信息网络向公众传播并获得报酬等权利；您应在改编作品中注明作品原创作者的姓名/名称。`

//预售购买须知
export const presaleBuyNote = `1. 本作品为预售作品，仅限实名认证的中国大陆用户且满18周岁的人群购买。
2. 本作品完成预售目标后，版权方将按页面显示的发放截止时间前将所属您的作品发放至您的平台账户，您理解并同意，发放作品为版权方预售作品系列中的随机一幅，不可指定。如最终预售目标未达成，即视为此次预售活动失败，您所支付款项将由无界版图系统自动退回给您的平台账户。
3. 预售作品统一出售的是版权所有权，作品发放至您的账户后，您需点击“立即领取”按钮，并设置作品版权所有权的下次出售价格。领取成功后您即是该作品的权利人，您所享有具体权益见《版权所有权权益须知》
4. 版权作品为虚拟物品，您一旦参与预售活动，则不支持退换。
5. 依据法律要求，我们坚决反对作品版权的炒作、违规交易、侵权方式使用等行为。
6. 为提高您的用户体验，请您务必审慎阅读并同意相关协议规则后进行相应操作，以免造成不必要损失。`

//预售所有权须知
export const presaleOwnerNote = `1. 预售作品发放至您的账户后，即视为您享有该作品的版权所有权，版权方将同时向您转让作品的具体信息，包括但不限于作品名称、尺寸、创作年代、作品介绍等，如作品涉及肖像权或物权的，相应权利将同时转授权至版权受让方。
2. 版权方向您转让的原创作品版权的著作财产权包括但不限于复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权，以及著作权人享有的其他著作财产相关权利（人身权除外）。
3. 转让时限自您受让成功之时起，直至您将该作品版权所有权再次售出。
4. 版权转让后，版权方无权限制您就作品版权使用权的授权活动，亦不能再就版权收益向您提供进一步要求。
5. 版权方同意，您有权为指定作品及其作者进行线上线下媒体宣传推广；作品版权在宣传、推广活动时涉及的作者信息（含作者姓名、肖像、个人简介）和作品信息的，您有权无限制免费使用。
6. 以上权利转让是排他的、独占的。版权方不得将指定作品的版权再次转让、授权给任何第三方，也不得自行开发。版权方违反上述约定的，应向您承担赔偿责任。
7. 未经无界版图平台书面同意，您不得自行通过除无界版图平台外的其他渠道或方式，就作品版权进行任何形式的处分或授权。`

/** AI版权作品须知
 */
export const AINote = {
  buyTip: `您需特别注意，由于人工智能创作作品的法律法规尚在完善和仍在发展变化中，AI作品是否属于著作权法保护范围尚存争议，其权利认定、权利归属及法律性质可能会因为法律法规的发展发生变化，您在购买前已了解清楚，并自愿承受因此法律风险（比如无法进行版权登记、AI作品不具有著作权等）及后续法律法规的不利变化可能产生的所有风险。`,
  equityNote: `一、AI作品版权权益须知：
1.您在购买AI作品版权后，转让方将同时向您转让作品的具体信息，包括但不限于作品名称、尺寸、创作参数、关键词、画面描述、作品介绍等。如作品涉及使用底图或肖像权的，则转让方在此许可受让方使用。
2.转让方向您转让的AI作品著作财产权包括但不限于复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权，及著作权人享有的其他著作财产相关权利（人身权除外）。具体以国家法律法规认定为准。
3.您理解并同意，一旦买断该作品版权，仅限于您个人使用，您不得再次将该作品上架交易或转让给他人，不得再次售卖该作品的授权许可使用权、改编权等著作权或其他衍生权利，即不得对外授权许可第三方以任何方式使用作品。
4.作品转让后，转让方无权限制您就作品版权的授权活动，亦不能再就作品收益向您提供进一步要求。但您不得将该图片用于任何违反国家法律法规、政策、社会公序良俗或者色情淫秽、不道德的用途。
5.转让方同意，您有权为指定作品及其作者进行线上线下媒体宣传推广；作品在宣传、推广活动时涉及的作者信息（含作者姓名、肖像、个人简介）和作品信息的，您有权无限制免费使用。
6.以上权利转让是排他的、独占的。转让方不得将指定作品的版权再次转让、授权给任何第三方，也不得自行开发。转让方违反上述约定的，应向您承担赔偿责任。

二、使用权权益须知：
1.标准授权：无界版图授权您在有限的商业用途中使用作品，具体授权范围以授权许可协议为准。
2.扩展授权：无界版图授权您在较为广泛的商业用途中使用作品，具体授权范围以授权许可协议为准。
3.商品类授权：无界版图授权您在较为广泛的商业用途中使用作品，具体授权范围以授权许可协议为准。
4.购买许可使用权后，不视为版权已转让给被授权人，除协议中明确陈述的授权之外，无界版图未授予被授权人对作品的其他任何权利。
5.您不得超出授权协议条款所约定和允许的使用范围。
6.在本平台任何文件中，如无特别说明的，作品授权使用权/使用许可均不包括作品改编权/改编许可。

三、改编权权益须知：
1.您按页面提示购买作品改编权后，可将作品改编为具有独创性的新作品，但一次购买仅对应唯一被授权主体，仅允许一位自然人或一个法人或一个非法人组织下载一次、改编一次作品。
2.您在获得作品改编权后，不得侵犯原作者的署名权、修改权、保护作品完整权等作品著作人身权利，亦不得侵犯未经授权的作品其他财产权利。
3.改编作品创作完成后，您依法享有改编作品的著作权，并享有包括但不限于许可他人复制、发行、出租、通过信息网络向公众传播并获得报酬等权利；您应在改编作品中注明作品原创作者的姓名/名称。
    `,
  buyNote: `1.依据法律要求，我们坚决反对作品的炒作、违规交易、侵权使用等行为。
2.交易作品为虚拟商品，仅限实名认证的中国大陆用户且满18岁人群购买。
3.AI作品一经出售不支持退换。
4.为更好服务无界版图平台的各位用户，请各位用户务必审慎阅读并同意相关协议规则后进行相应操作，以免造成不必要损失。
  `,
}
